(function () {
  document.querySelectorAll("[data-zeus-riders-tabs]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-zeus-riders-tab]");
    var descs = root.querySelectorAll("[data-zeus-riders-desc]");
    var cards = root.querySelectorAll("[data-zeus-riders-card]");
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var category = tab.getAttribute("data-zeus-riders-tab");
        tabs.forEach(function (t) {
          t.classList.toggle("is-active", t === tab);
          t.setAttribute("aria-selected", t === tab ? "true" : "false");
        });
        descs.forEach(function (d) {
          d.hidden = d.getAttribute("data-zeus-riders-desc") !== category;
        });
        cards.forEach(function (card) {
          card.hidden = card.getAttribute("data-zeus-riders-card") !== category;
        });
      });
    });
  });
})();
